import React from 'react';
import { SuccessDisplay } from '../SuccessDisplay';
import { FormHeader } from '../FormHeader';
import { Show } from 'components/shared/Show';
import { eAccessControlUserType } from '../../../ui-toolkit/enums/eAccessControlUserType';
import { CreatingDisplay } from '../CreatingDisplay';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { useHistory } from 'react-router-dom';
import { NewOrderSpaceWrapping } from './NewOrderSpaceWrapper';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query/react';
import { SerializedError } from '@reduxjs/toolkit';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export interface IFormWrapperProps {
  userType: eAccessControlUserType;
  error?: FetchBaseQueryError | SerializedError;
  isLoading?: boolean;
  isSuccess?: boolean;
}

const redirectDestination = (userType: eAccessControlUserType): string => {
  if (userType === eAccessControlUserType.Client) {
    return clientUrls.urlFor.clientOrders();
  }
  return clientUrls.urlFor.adminOrders();
};

// Responsible for rendering the Header, Error Message, and Creating Display
export const FormWrapper: FCWithChildren<IFormWrapperProps> = ({ children, userType, error, isLoading, isSuccess }) => {
  const history = useHistory();

  const onCancel = () => history.push(redirectDestination(userType));

  if (isSuccess) return <SuccessDisplay />;

  return (
    <>
      <FormHeader onCancel={onCancel} />
      <Show when={!!error}>
        <NewOrderSpaceWrapping>
          <ErrorMessageTW rtkError={error} />
        </NewOrderSpaceWrapping>
      </Show>
      {children}
      <CreatingDisplay isFetching={isLoading ?? false} />
    </>
  );
};
